import(/* webpackMode: "eager" */ "/app/src/app/articles/layout.tsx");
